export default "__VITE_ASSET__DPD7VhJY__"